import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import MerchantV2Content from "./MerchantV2Content";
import { merchantV2Service } from '../../service/firebase/merchantV2Service';
import type { MerchantV2 } from '../../type';

const MerchantV2Page = () => {
  const queryClient = useQueryClient();

  // 상점 목록 조회
  const { data: merchants = [], isLoading, error } = useQuery({
    queryKey: ['merchants-v2'],
    queryFn: () => merchantV2Service.getAll(),
  });

  // 상점 추가
  const addMerchantMutation = useMutation({
    mutationFn: (merchant: MerchantV2) => merchantV2Service.create(merchant),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merchants-v2'] });
    },
  });

  // 상점 수정
  const updateMerchantMutation = useMutation({
    mutationFn: (merchant: MerchantV2) => merchantV2Service.update(merchant.merchant_id, merchant),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merchants-v2'] });
    },
  });

  // 상점 삭제
  const deleteMerchantMutation = useMutation({
    mutationFn: (merchant_id: string) => merchantV2Service.delete(merchant_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merchants-v2'] });
    },
  });

  const handleAddMerchant = async (merchant: MerchantV2) => {
    await addMerchantMutation.mutateAsync(merchant);
  };

  const handleUpdateMerchant = async (merchant: MerchantV2) => {
    await updateMerchantMutation.mutateAsync(merchant);
  };

  const handleDeleteMerchant = async (merchantId: string) => {
    await deleteMerchantMutation.mutateAsync(merchantId);
  };

  return (
    <MerchantV2Content
      merchants={merchants}
      loading={isLoading}
      error={error?.message || null}
      addMerchant={handleAddMerchant}
      updateMerchant={handleUpdateMerchant}
      deleteMerchant={handleDeleteMerchant}
    />
  );
};

export default MerchantV2Page;
